import React, { useState } from 'react'
import { Button, Form, Input } from 'antd'
import { useAppDispatch } from 'Hooks/ReduxHook'
import { SignIn, SignInDevBypass } from 'Store/services/auth.service'
import { useNavigate } from 'react-router-dom'
import { type ILoginUser } from 'Util/Interface'
import { isDevBypassAuthEnabled } from 'Util/devAuth'

const LoginPage: React.FC = () => {
  const [isLoading, setLoader] = useState(false)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleSubmit = (values: ILoginUser) => {
    setLoader(true)
    dispatch(SignIn(values))
      .unwrap()
      .then(() => {
        setLoader(false)
        navigate('/')
      })
      .catch(() => {
        setLoader(false)
      })
  }

  const handleDevLogin = () => {
    setLoader(true)
    dispatch(SignInDevBypass())
      .unwrap()
      .then(() => {
        setLoader(false)
        navigate('/')
      })
      .catch(() => {
        setLoader(false)
      })
  }

  return (
    <>
      <div className="auth-wrapper">
        <div className="auth-bg-wrapper">
          <div className="login-wrapper">
            <div className="form-wrapper">
              <Form layout="vertical" onFinish={handleSubmit} requiredMark="optional" autoComplete="off">
                <div className="form-title">Login App</div>
                <div className="login-description">Enter Authentication Details</div>
                <Form.Item
                  name="email"
                  label={'Email'}
                  rules={[
                    { required: true, message: 'Enter Email Address' },
                    {
                      type: 'email',
                      message: 'Enter Valid Email Address',
                    },
                  ]}
                >
                  <Input className="custom-input" placeholder={'Email'} />
                </Form.Item>
                <Form.Item label={'Password'} name="password" rules={[{ required: true, message: 'Enter Password' }]}>
                  <Input.Password className="custom-input" placeholder={'Password'} />
                </Form.Item>
                <Form.Item noStyle>
                  <Button className="custom-button mt-4" type="primary" htmlType="submit" loading={isLoading}>
                    Login
                  </Button>
                </Form.Item>
                {isDevBypassAuthEnabled && (
                  <>
                    <p className="login-description mt-3" style={{ fontSize: 12 }}>
                      Production login failing? Use local dev access to open the dashboard on this PC only. Data still needs a real admin password on the server.
                    </p>
                    <Button className="custom-button mt-2" block onClick={handleDevLogin} loading={isLoading}>
                      Continue locally (dev only)
                    </Button>
                  </>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginPage
